import { createIcon } from "@chakra-ui/react"

export const CheckmarkIcon = createIcon({
  displayName: "Success",
  viewBox: "0 0 24 24",
  d: "M9.525 17.657l-4.95-4.95 1.414-1.414 3.537 3.534-.001.001 8.485-8.485 1.414 1.414-8.485 8.486-1.413 1.413-.001.001z",
})
